// NavSearchDropdown — populates SearchBar > Dropdown with grouped global
// search results. The parent SearchBar extends DropdownParentFocus, which
// shows [dropdown] children on :focus-within via CSS.

export const NavSearchResultGroup = {
  flow: 'y',

  GroupHeader: {
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    padding: 'Y1 A',

    Icon: {
      name: (el, s) => s.icon || 'search',
      boxSize: 'Z2 Z2',
      color: 'caption'
    },
    GroupLabel: {
      text: (el, s) => s.label || '',
      fontSize: 'Y2',
      fontWeight: '600',
      color: 'caption',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  },

  Items: {
    flow: 'y',
    children: (el, s) => s.items || [],
    childExtends: 'NavSearchResultItem',
    childrenAs: 'state'
  }
}

export const NavSearchResultItem = {
  extends: 'Link',
  flow: 'x',
  align: 'center left',
  gap: 'Z',
  padding: 'Y1 A',
  cursor: 'pointer',
  textDecoration: 'none',
  round: 'Y',
  ':hover': { background: 'gray.05' },

  href: (el, s) => s._href || '#',

  onClick: (e, el, s) => {
    e.preventDefault()
    el.call('navigateSearchResult', s._href)
  },

  ResultTitle: {
    flex: '1',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    text: (el, s) => s._title || ''
  },

  ResultSubtitle: {
    fontSize: 'Y2',
    color: 'caption',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 'F',
    text: (el, s) => s._subtitle || '',
    hide: (el, s) => !s._subtitle
  }
}
